'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var vaccinesComponent = exports.vaccinesComponent = {
    template: require('./vaccines.html'),
    bindings: {
        vaccines: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsOverviewService", "Enums", "gettextCatalog", "vaccinesService", "Analytics", "toastr", function vaccinesController($scope, common, newsOverviewService, Enums, gettextCatalog, vaccinesService, Analytics, toastr) {
        'ngInject';

        var vm = this;
        vm.$onInit = init;
        vm.saveVaccinesOrder = saveVaccinesOrder;
        vm.isActiveDiscount = isActiveDiscount;
        vm.getBannerImage = getBannerImage;
        vm.hasVaccinesOrdered = hasVaccinesOrdered;
        vm.getBannerImageEnded = getBannerImageEnded;
        vm.canOrder = canOrder;
        vm.anyReservationsMade = false;
        vm.allReservationsMade = false;
        vm.unModifiedVaccines = [];
        vm.reservationCanBeMade = false;

        function init() {
            common.setTitle(gettextCatalog.getString('My reservations'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/account/myReservations', gettextCatalog.getString('My reservations'));
            vm.unModifiedVaccines = deepCopy(vm.vaccines);
            vm.anyReservationsMade = vaccinesService.vaccinsCanOrder(vm.unModifiedVaccines);
            vm.allReservationsMade = vaccinesService.allReservationsMade(vm.unModifiedVaccines);
            vm.reservationCanBeMade = vaccinesService.canOrderVaccin();
        }

        function hasVaccinesOrdered() {
            return !!vm.unModifiedVaccines.find(function (v) {
                return v.amount > 0;
            });
        }

        function canOrder(vaccin) {
            var res = vaccinesService.canOrderVaccin(vm.unModifiedVaccines.find(function (v) {
                return v.productNumber === vaccin.productNumber;
            }));
            if (vaccin.productNumber === '4307617' && vm.vaccines.influvacReadOnly) {
                return false;
            }
            return res;
        }

        function saveVaccinesOrder() {
            vaccinesService.setVaccinReservation(vm.vaccines).then(function () {

                vm.unModifiedVaccines = deepCopy(vm.vaccines);
                vm.anyReservationsMade = vaccinesService.vaccinsCanOrder(vm.unModifiedVaccines);
                vm.allReservationsMade = vaccinesService.allReservationsMade(vm.unModifiedVaccines);

                toastr.success(gettextCatalog.getString('Your reservation has been confirmed.'), '', {
                    progressBar: true,
                    timeOut: 5000,
                    extendedTimeOut: 1000,
                    closeButton: true
                });
            });
        }

        function isActiveDiscount(vaccine, discount) {
            var nextDiscount = null;
            vaccine.discounts.forEach(function (e) {
                if (vaccine.amount >= e.amount) {
                    nextDiscount = e;
                }
            });
            return nextDiscount && nextDiscount.amount === discount.amount ? 'bg-info-light' : '';
        }

        function getBannerImage() {
            var currentLanguage = common.localization.getCurrentLanguage();

            if (currentLanguage === 'nl') {
                return '/Common/griepvaccin-nl.png';
            } else if (currentLanguage === 'fr') {
                return '/Common/griepvaccin-fr.png';
            }
        }

        function getBannerImageEnded() {
            var currentLanguage = common.localization.getCurrentLanguage();

            if (currentLanguage === 'nl') {
                return '/Common/griepvaccin-no-text.png';
            } else if (currentLanguage === 'fr') {
                return '/Common/griepvaccin-no-text.png';
            }
        }

        function deepCopy(o) {
            var copy = o,
                k;

            if (o && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object') {
                copy = Object.prototype.toString.call(o) === '[object Array]' ? [] : {};
                for (k in o) {
                    copy[k] = deepCopy(o[k]);
                }
            }

            return copy;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/vaccines/vaccines.js
// module id = 1032
// module chunks = 0